import { type IMobileApplications } from "@next-platform/client-common-core";

import { ANDROID_PLATFORM_OS, IOS_PLATFORM_OS } from "./constants";

export type BrandedMobileApplication = {
  brandId: string;
  androidApplication?: IMobileApplications;
  iosApplication?: IMobileApplications;
};

export function normalizeMobileApplicationBrand(brand: string | undefined): string | undefined {
  const normalizedBrand = brand?.trim().toLowerCase();
  return normalizedBrand || undefined;
}

export function getBrandedMobileApplications({
  mobileApplications,
}: {
  mobileApplications: IMobileApplications[] | null | undefined;
}): BrandedMobileApplication[] {
  const configuredMobileApplications = mobileApplications ?? [];
  const brandedApplicationsById = new Map<string, BrandedMobileApplication>();
  const brandOrder: string[] = [];

  for (const mobileApplication of configuredMobileApplications) {
    if (mobileApplication.type !== ANDROID_PLATFORM_OS && mobileApplication.type !== IOS_PLATFORM_OS) {
      continue;
    }

    const brandId = normalizeMobileApplicationBrand(mobileApplication.brand);
    if (!brandId) {
      continue;
    }

    let brandedApplication = brandedApplicationsById.get(brandId);
    if (!brandedApplication) {
      brandedApplication = { brandId };
      brandedApplicationsById.set(brandId, brandedApplication);
      brandOrder.push(brandId);
    }

    if (mobileApplication.type === ANDROID_PLATFORM_OS && !brandedApplication.androidApplication) {
      brandedApplication.androidApplication = mobileApplication;
    }

    if (mobileApplication.type === IOS_PLATFORM_OS && !brandedApplication.iosApplication) {
      brandedApplication.iosApplication = mobileApplication;
    }
  }

  return brandOrder.map((brandId) => brandedApplicationsById.get(brandId)!);
}

export function getCurrentBrandMobileApplications({
  brandedApplications,
  currentApplicationId,
}: {
  brandedApplications: BrandedMobileApplication[];
  currentApplicationId: string;
}): BrandedMobileApplication | undefined {
  const normalizedCurrentApplicationId = currentApplicationId.trim().toLowerCase();

  return brandedApplications.find(({ brandId }) => brandId === normalizedCurrentApplicationId);
}
